import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UmbracoImage } from 'src/core-lib/umbraco/umbraco-image.model';
import { MenuConfiguration } from '../../models/main-configuration.model';


@Pipe({
    name: 'menuToCta'
})
export class MenuToCtaPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer) {}

    transform(menu: Partial<MenuConfiguration>): null | {
        color?: string,
        backgroundColor?: string,
        backgroundImage?: UmbracoImage,
        fontFamily?: string,
        text: SafeHtml,
        link:string,
    } {
        if (
            menu?.ctaText == null
        )
            return null;
        return {
            color: menu?.ctaColor,
            backgroundColor: menu?.ctaBackgroundColor,
            backgroundImage: menu?.ctaBackgroundImage,
            fontFamily: menu?.ctaFontFamily,
            text: this.sanitizer.bypassSecurityTrustHtml(menu.ctaText),
            link: menu.ctaLink,
        }
    }

}
